module.exports = __webpack_public_path__ + "static/ambient-0dfcbd202fb49a663b7551b592cf956e.mp3";